// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".updates__block-grid-item header[data-v-e7226f5e]{background:#f4eddd;border-bottom:none}.updates__block-grid-item header .cell--date[data-v-e7226f5e]{padding:.625rem .625rem 0}.updates__block-grid-item header .cell--date[data-v-e7226f5e] .article-date{color:#2a7980;font-weight:700}.updates__block-grid-item .cell--body[data-v-e7226f5e]{padding-top:.5rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
